<template>
  <!-- 三级分区漏损排名 -->
  <div class="mainWarp">
    <div class="img-title">
      <img src="/iconImg/h_title_bg.png" />
      <span class="DataTitle">产销差排名</span>
    </div>
    <div class="bigBox">
      <div class="headerUnit">
        <span style="width:28px">排名</span>
        <span style="width:252px;margin-left:17px">片区名称</span>
        <span style="width:50px;">产销差率</span>
      </div>
      <div class="dataWarp">
        <div class="dataItem" v-for="(item, index) in dataList" :key="index">
          <div class="ranking">{{ index + 1 }}</div>
          <div class="dataMid">
            <div class="progress">
              <div class="dataMidWarp" :style="{ width: item.length }"></div>
              <div class="dataMidWarpAfter"></div>
            </div>
            <span>{{ item.zoneName }}</span>
          </div>
          <div class="dataValue">{{ item.leakageRate }}%</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LeakageRanking',
  components: {},
  data () {
    return {
      dataList: []
      // dataList: [
      //   {
      //     name: '白云路片区',
      //     rate: '0.8%',
      //     id: 1
      //   }
      // ]
    }
  },
  computed: {
    // dataList() {
    //   var list = [
    //     {
    //       name: '白云路片区',
    //       rate: '0.8%',
    //       length:'234px',
    //       id: 1
    //     }
    //   ]
    //   for (let i = 2; i < 16; i++) {
    //     list.push({
    //       name: '片区名称' + i,
    //       rate: '0.8%',
    //       length: i % 2 == 0 ? '199px' : i % 3 == 0 ? '183px' : '234px',
    //       id: i
    //     })
    //   }
    //   return list
    // }
  },
  created () {
    // this.getMockData()
    this.getLeakageRankingData()
  },
  methods: {
    getLeakageRankingData () {
      this.$http.get('/pipe-network/report/chart/zone-leakage/ranking').then(res => {
        this.dataList = res.data
        this.dataList.map((item) => {
          item.length = (1 - (parseFloat(item.leakageRate) * 0.01)) * 240 + 'px'
          return item
        })
      })
    },
    getMockData () {
      const list = [
        {
          name: '新城东',
          rate: '2.19',
          length: '234px'
        },
        {
          name: '新城西',
          rate: '2.15%',
          length: '234px'
        },
        {
          name: '西街',
          rate: '2.04%',
          length: '234px'
        },
        {
          name: '东西正街',
          rate: '1.56%',
          length: '234px'
        },
        {
          name: '郴义路南',
          rate: '2.42%',
          length: '234px'
        },
        {
          name: '卢阳大道北',
          rate: '2.39%',
          length: '234px'
        },
        {
          name: '土桥',
          rate: '3.19%',
          length: '234px'
        },
        {
          name: '郴义路北',
          rate: '1.12%',
          length: '234px'
        },
        {
          name: '朝阳路',
          rate: '3.08%',
          length: '234px'
        },
        {
          name: '云头路',
          rate: '2.04%',
          length: '234px'
        },
        {
          name: '人民医院-予乐湾片区',
          rate: '1.93%',
          length: '234px'
        },
        {
          name: '文化路',
          rate: '2.35%',
          length: '234px'
        },
        {
          name: '九塘江',
          rate: '1.71%',
          length: '234px'
        },
        {
          name: '四号南',
          rate: '1.89%',
          length: '234px'
        },
        {
          name: '六中',
          rate: '1.91%',
          length: '234px'
        }
      ]
      list.map(item => {
        item.rate = parseFloat(item.rate)
        return item
      })
      console.log(list)
      list.sort((a, b) => {
        return a.rate - b.rate
      })
      list.map((item, index) => {
        item.length = (1 - (item.rate * 0.01)) * 250 + 'px'
        item.rate = item.rate + '%'
        item.id = index + 1
        return item
      })
      console.log(list)
      this.dataList = list
    }
  }
}
</script>

<style lang="less" scoped>
.mainWarp {
  height: 254px;
  width: 376px;
  background: url(~@/assets/myImg/box-06.png) no-repeat;
  background-size: cover;
  position: relative;

  .img-title {
    position: absolute;
    position: relative;
    top: -20px;
    text-align: center;
    font-family: MicrosoftYaHeiSemibold;
    font-size: 18px;
    color: #00ebee;
    font-weight: 600;
    line-height: 30px;

    .DataTitle {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
    }

    img {
      //   position: absolute;
      width: 264px;
      height: 40px;
    }
  }

  .bigBox {
    height: 214px;
    width: 100%;
    // padding: 0 18px;
    padding-left: 18px;

    .headerUnit {
      width: 100%;
      height: 20px;
      display: flex;
      flex-direction: row;
      // justify-content: space-around;
      align-items: center;
      text-align: center;

      span {
        font-family: MicrosoftYaHei;
        font-size: 12px;
        color: #98bdff;
        text-align: left;
        font-weight: 400;
      }
    }

    .dataWarp {
      height: 190px;
      width: 100%;
      padding-bottom: 10px;
      overflow-x: hidden;
      overflow-y: auto;

      .dataItem {
        width: 100%;
        height: 28px;
        display: flex;
        margin-top: 18px;

        .ranking {
          background: #007bab;
          height: 28px;
          width: 28px;
          line-height: 28px;
          text-align: center;
          font-family: MicrosoftYaHeiSemibold;
          font-size: 16px;
          color: #ffffff;
          font-weight: 600;
        }

        .dataMid {
          margin-left: 7px;
          background: rgba(0, 200, 255, 0.15);
          height: 28px;
          width: 240px;
          position: relative;

          .progress {
            position: absolute;
            display: flex;

            .dataMidWarp {
              // width: 234px;
              height: 28px;
              background-image: linear-gradient(270deg, rgba(0, 200, 255, 0.62) 0%, rgba(0, 200, 255, 0.1) 100%);
            }

            .dataMidWarpAfter {
              width: 3px;
              height: 28px;
              background: #00c8ff;
            }
          }

          span {
            font-family: MicrosoftYaHei;
            font-size: 13px;
            color: #ffffff;
            font-weight: 400;
            margin-left: 14px;
            line-height: 28px;
          }
        }

        .dataValue {
          height: 28px;
          width: 40px;
          margin-left: 10px;
          line-height: 28px;
          font-family: MicrosoftYaHei;
          font-size: 13px;
          color: #10c0ff;
          text-align: center;
          font-weight: 400;
        }
      }

      .dataItem:nth-child(1) {
        margin-top: 10px;
      }
    }

    .dataWarp::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 10px;
      /*高宽分别对应横竖滚动条的尺寸*/
      height: 1px;
    }

    .dataWarp::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: rgba(255, 255, 255, 0.35);
      border-radius: 5px;
    }

    .dataWarp::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: rgba(255, 255, 255, 0.05);
      border-radius: 4px;
    }
  }
}
</style>
